import { get as getCookie, set as setCookie } from 'js/lib/cookie';

import type { PathwayCompletedState } from 'bundles/unified-home-common/contexts/PathwayCompletedStateContext';

const COOKIE_NAME = 'pathwayCompletedState';

export const setCompletedStateCookie = (state: PathwayCompletedState) => {
  setCookie(COOKIE_NAME, JSON.stringify(state), { days: 60 });
};

export const getCompletedStateCookie = (): PathwayCompletedState | undefined => {
  try {
    const plainCookieData = getCookie(COOKIE_NAME);

    if (plainCookieData) {
      return JSON.parse(plainCookieData) as PathwayCompletedState;
    }

    return undefined;
  } catch {
    return undefined;
  }
};
